import { AbstractModel, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ReservationStatusUpdate extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  reservationStatusName: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserializeAs(Date)
  timestamp: Date;

  @autoserialize
  deviceInstallationId: number;

  /**** Serialization ****/

  static OnSerialized(instance: ReservationStatusUpdate, json: any): void {
    super.OnSerialized(instance, json);

    // Make sure there isn't too much precision for database
    if (!isNullOrUndefined(instance.latitude)) {
      json.latitude = parseFloat(instance.latitude.toFixed(6));
    }
    if (!isNullOrUndefined(instance.longitude)) {
      json.longitude = parseFloat(instance.longitude.toFixed(6));
    }
  }
}
